<template>
  <div class="col-12">
    <hr />
    <EditorGroupToggle
      label="Webinar Settings"
      target="toggleGroupWebinar"
      class="mb-4"
      :collapsed="false"
    />
    <div id="toggleGroupWebinar" class="collapse show row">
      <div class="col-12 mb-3">
        <Field
          type="text"
          name="webinar_url"
          label="Webinar URL *"
          :value="event.webinar_url"
        />
      </div>
      <div class="col-12 mb-3">
        <HtmlField
          name="webinar_notes"
          label="Additonal Webinar Details"
          :value="event.webinar_notes"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
  },
};
</script>